export default (function (_ref) {
  var onOk = _ref.onOk,
    okText = _ref.okText,
    cancelText = _ref.cancelText,
    title = _ref.title;
  if (confirm(title)) {
    onOk();
  }
});